import { useSearchParams } from 'react-router-dom';
import { Tabs } from '@/design-system';
import { WhatsAppServersSection } from '@/features/whatsapp-servers';
import { WhatsAppPricingSection } from './WhatsAppPricingSection';
import { MetaSection } from './MetaSection';
import { MetaChannelAvailabilitySection } from './MetaChannelAvailabilitySection';

export function ChannelsSection() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'uazapi' ? 'uazapi' : params.get('tab') === 'pricing' ? 'pricing' : 'meta';
  return <div className="space-y-6">
    <header><h2 className="text-xl font-semibold text-gray-900">Canais</h2>
      <p className="mt-1 text-sm text-gray-500">Configurações dos canais de comunicação: Meta (WhatsApp Cloud, Instagram, Messenger) e Uazapi (WhatsApp QR via servidores próprios).</p></header>
    <Tabs label="Configurações de canais" value={tab} onChange={(value) => setParams({ tab: value }, { replace: true })}
      tabs={[
        { value: 'meta', label: 'Meta', content: <div className="space-y-6"><MetaSection /><MetaChannelAvailabilitySection /></div> },
        { value: 'pricing', label: 'Preços WhatsApp', content: <WhatsAppPricingSection /> },
        { value: 'uazapi', label: 'Uazapi', content: <WhatsAppServersSection embedded /> },
      ]} />
  </div>;
}
